import { useQuizContext } from "@/pages/quiz/context";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { Header } from "@/pages/quiz/15000/components/Header";
import { QuestionPrerenderContainer } from "@/pages/quiz/components/questionPrerenderContainer";
import { ProgressSection } from "@/pages/quiz/15000/components/ProgressSection";
import { QuestionContentDisplay } from "@/pages/quiz/15000/components/QuestionContentDisplay";
import { QuestionPreview } from "@/pages/quiz/15000/components/QuestionPreview";
import { NoFoundQuestionError } from "@/pages/quiz/15000/components/NoFoundQuestionError";
import { AnimatedContainer } from "@/components/common/animatedContainer";
import { getQuestionBlock } from "@/pages/quiz/15000/common/blockMapper";
import { FC } from "react";
import { useThemeColor } from "@/hooks/useThemeColor";

interface IProps {
  quizId?: string;
}

const QuizV4: FC<IProps> = ({ quizId }) => {
  useThemeColor("#ffffff");

  const {
    questions,
    selectedQuestion,
    answers,
    uploadUserId,
    isPrerenderEnabled,
    selectedQuestionIdx,
    onChangeQuestionValue,
    onAnswer,
    onBack,
  } = useQuizContext();

  const { Component, config } = getQuestionBlock(selectedQuestion);

  useScrollToTop([selectedQuestion?.id]);

  const questionHasAnswer =
    !!selectedQuestion?.id && !!answers?.[selectedQuestion?.id]?.value;

  const isRenderQuestionContentDisplay =
    !!selectedQuestion && !!selectedQuestion.attributes.question;

  const isDisablePreview =
    questionHasAnswer || !!selectedQuestion?.answers?.length;

  const isDisableAnimation =
    !config?.enableAnimation || !!selectedQuestion?.answers?.length;

  return (
    <div className="font-sofia h-dvh">
      <div className="h-full flex flex-col justify-start max-w-[650px] mx-auto sm:pb-8">
        <Header />
        <ProgressSection />

        {selectedQuestion && (
          <QuestionPreview
            PreviewComponent={config?.PreviewComponent}
            disablePreview={isDisablePreview}
          >
            <div className="w-full mt-8 px-4 md:px-0 md:mt-10">
              {isRenderQuestionContentDisplay && (
                <QuestionContentDisplay
                  question={selectedQuestion?.attributes?.question}
                  prompt={selectedQuestion?.attributes?.prompt}
                  customHTML={selectedQuestion?.attributes?.customHTML}
                  descriptionBlock={
                    selectedQuestion?.attributes?.descriptionBlock
                  }
                />
              )}

              <AnimatedContainer
                questionId={selectedQuestion.id}
                disableAnimation={isDisableAnimation}
              >
                <Component
                  key={selectedQuestion.id}
                  questionValue={
                    (answers[selectedQuestion.id]?.value as any) ?? ""
                  }
                  setQuestionAnswer={async (
                    v: any,
                    useServerValidation = false,
                    disableApi = false
                  ) =>
                    onAnswer(
                      selectedQuestion.id,
                      v,
                      useServerValidation,
                      disableApi
                    )
                  }
                  setQuestionValue={(v: any, isAnswered = false) =>
                    onChangeQuestionValue({
                      questionId: selectedQuestion.id,
                      answer: v,
                      isAnswered,
                    })
                  }
                  onBack={onBack}
                  question={selectedQuestion}
                  uploadUserId={uploadUserId}
                  quizId={quizId}
                />
              </AnimatedContainer>
            </div>
          </QuestionPreview>
        )}

        {!selectedQuestion && <NoFoundQuestionError />}

        <QuestionPrerenderContainer
          questions={questions}
          selectedQuestionIdx={selectedQuestionIdx}
          isPrerenderEnabled={isPrerenderEnabled}
          getQuestionBlock={getQuestionBlock}
        />
      </div>
    </div>
  );
};

export { QuizV4 };
